import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class DeviceTypeService {
  public isMobile: boolean;
  public isTablet: boolean;
  public isDesktop: boolean;
  public isIOS: boolean;
  public devicePlatform: string = '';
  public deviceDetails: string = '';

  constructor(private readonly deviceDetectorService: DeviceDetectorService) {
    this.devicePlatform = (navigator as any)?.userAgentData?.platform || navigator.userAgent || '';
    this.deviceDetails = navigator.userAgent || '';
    this.isMobile = this.deviceDetectorService.isMobile();
    this.isTablet = this.deviceDetectorService.isTablet();
    this.isDesktop = this.deviceDetectorService.isDesktop();
    this.isIOS = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
    const isAndroidTablet =
      (this.devicePlatform === 'Android' || navigator.userAgent.includes('SamsungBrowser')) &&
      (this.isDesktop || (this.isMobile && window.matchMedia('(min-width: 768px)').matches));
    const isIpad = navigator.userAgent.includes('iPad');
    if (isAndroidTablet || isIpad) {
      this.isTablet = true;
      this.isDesktop = false;
      this.isMobile = false;
    } else if (navigator.userAgent.includes('iPod') || navigator.userAgent.includes('iPhone')) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (navigator.userAgent.includes('Macintosh')) {
      this.isMobile = false;
      this.isTablet = false;
      this.isDesktop = true;
    }

    // Forcing tablet mode if none detected
    if (!this.isDesktop && !this.isMobile && !this.isTablet) {
      this.isTablet = true;
    }
  }
}
